import React from 'react';
import DebiaProcess from 'app/components/OrderPayment/Debia/DebiaProcess';

const DebiaPaymentMob = () => {
  return <DebiaProcess />;
};

export default DebiaPaymentMob;
